import { ErrorManagement } from '@printdeal/error-management/react';
import Api from '../Api';
import { windowPresent } from '../../helpers/window';

const getBaseUrlWithPath = (): string => {
  if (!windowPresent) return '';
  const { origin, pathname } = new URL(window.location.href);
  return origin + pathname;
};

class SurfaceDependencyService extends Api {
  getTechnicalDrawingPdfUrl = async (
    productId: string,
    productName: string,
    selections: { [key: string]: string },
    locale: string,
    version?: number,
  ): Promise<{ status: 'READY' | 'IN_PROGRESS', resultUrl: string }> => {
    try {
      const url = getBaseUrlWithPath();
      const { data } = await this.httpClient.post(
        '/v2/templates',
        {
          productId,
          version,
          selections: {
            ...selections,
            product_loc_name: productName,
            product_loc_pdp: url,
          },
          accountId: 'noS5wU4XH2WRmkaqKqTpfH',
          templateParameters: {
            requiredFiles: ['pdf', 'independentInstructions'],
            outputFormat: 'zip',
            locale,
          },
        },
      );
      return data;
    } catch (error) {
      ErrorManagement.exception({
        exception: error,
        extra: {
          productId,
          version,
          selections: JSON.stringify(selections),
        },
        tags: {
          component: 'summary',
          fileLocation: 'SurfaceDependencyService.ts',
          featureFunction: 'getTechnicalDrawingPdfUrl',
        },
        fingerprint: ['printdeal-pdf-template-download'],
      });
      throw error;
    }
  };
}

export default SurfaceDependencyService;
